import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ButtonBase from '@mui/material/ButtonBase';

import Logo from './LogoMain';
import LogoIcon from './LogoIcon';
import { useShellConfig } from 'contexts/ShellConfigContext';

export default function LogoSection({ reverse, isIcon, sx, to }) {
  const { homePath } = useShellConfig();
  return (
    <ButtonBase disableRipple component={Link} to={to || homePath} sx={sx} aria-label="Logo">
      {isIcon ? <LogoIcon /> : <Logo reverse={reverse} />}
    </ButtonBase>
  );
}

LogoSection.propTypes = { reverse: PropTypes.bool, isIcon: PropTypes.bool, sx: PropTypes.any, to: PropTypes.any };
